<!--
 * @Author: WLL
 * @Date: 2020-04-29 17:46:31
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-06 20:48:29
 * @Description: 行业选择器
 -->
<template>
  <RichDropDownTree
    ref="dropdownTree"
    :showLabel="showLabel"
    :data="typeMap[typeSelected].data"
    :clearable="clearable"
    :selected="typeMap[typeSelected].selected"
    @selectedChange="onSelectedChange"
    :radio-options="typeOptions"
    :radio-value="typeSelected"
    @radioChange="onTypeChange"
    @dropdownShow="onDropdownShow"
    @clear="onClear"
    @confirm="onConfirm"
    @expandChanged="onExpandChanged"
  ></RichDropDownTree>
</template>

<script>
import RichDropDownTree from "@/components/RichDropDownTree";

export default {
  name: "SelectIndustry",
  components: {
    RichDropDownTree
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    type: String,
    typeDefault: {
      type: String,
      default: "011"
    },
    maxNum: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,
      industryNameMap: {},
      typeMap: {
        "011": {
          name: "申万",
          value: "011",
          map: {},
          data: [],
          selected: []
        },
        "002": {
          name: "证监会",
          value: "002",
          map: {},
          data: [],
          selected: []
        }
      },
      typeSelected: this.typeDefault
    };
  },
  computed: {
    typeOptions() {
      return Object.values(this.typeMap).map(v => ({
        name: v.name,
        value: v.value
      }));
    },
    showLabel() {
      const { value, industryNameMap, typeMap, type } = this;
      if (Array.isArray(value) && value.length) {
        return value.map(v => industryNameMap[v]).join();
      }
      return type ? typeMap[type].name : "全部";
    },
    clearable() {
      const { value, type, typeDefault } = this;
      if (Array.isArray(value) && value.length) {
        return true;
      }
      return type !== typeDefault;
    }
  },
  created() {
    this.init();
  },
  methods: {
    onExpandChanged(key, val, name) {
      this.$emit("expandChanged", key, val, name);
    },
    init() {
      this.getIndustryList();
    },
    async getIndustryList() {
      try {
        this.loading = true;
        this.industryNameMap = {};
        const { typeMap } = this;
        Object.values(typeMap).forEach(v => {
          v.map = {};
          v.data = [];
        });
        const { data } = await this.$apis.Base.getIndustryList();
        const industryNameMap = {};
        data.forEach(v => {
          const categoryCode = v.CATEGORYCODE.substr(0, 3);
          if (v.PARENTCODE && typeMap[categoryCode]) {
            if (!typeMap[categoryCode].map[v.PARENTCODE]) {
              typeMap[categoryCode].map[v.PARENTCODE] = {
                id: v.PARENTCODE,
                label: v.PARENTNAME,
                childObj: {}
              };
            }
            if (v.PUBLISHCODE) {
              typeMap[categoryCode].map[v.PARENTCODE].childObj[
                v.PUBLISHCODE
              ] = {
                id: v.PUBLISHCODE,
                label: v.PUBLISHNAME
              };
              industryNameMap[v.PUBLISHCODE] = v.PUBLISHNAME;
            }
          }
        });
        this.industryNameMap = industryNameMap;
        const objToArr = obj => {
          const arr = [];
          Object.values(obj).forEach(v => {
            const newVal = {
              id: v.id,
              label: v.label
            };
            if (v.childObj) {
              newVal.children = objToArr(v.childObj);
            }
            arr.push(newVal);
          });
          return arr;
        };
        Object.values(typeMap).forEach(v => {
          v.data = objToArr(v.map);
        });
      } finally {
        this.loading = false;
      }
    },
    onTypeChange(val, label) {
      this.typeSelected = val;
      this.$emit("secondChange", label);
    },
    onSelectedChange(val, item) {
      const { typeMap, typeSelected, maxNum } = this;
      let currentSelected = [...typeMap[typeSelected].selected];
      const sameIndex = currentSelected.indexOf(item.id);
      if (sameIndex !== -1) {
        currentSelected.splice(sameIndex, 1);
      }
      if (val) {
        if (maxNum > 0 && currentSelected.length >= maxNum) {
          if (maxNum > 1) {
            currentSelected = currentSelected.slice(0 - (maxNum - 1));
          } else {
            currentSelected = [];
          }
          this.$nextTick(() => {
            this.$refs.dropdownTree.$refs.selectionTree.setRoot();
          });
        }
        currentSelected.push(item.id);
      }
      typeMap[typeSelected].selected = currentSelected;
    },
    onDropdownShow() {
      const { type } = this;
      if (type) {
        this.typeSelected = type;
      }
    },
    onConfirm() {
      const { typeSelected, typeMap } = this;
      this.$emit("input", [...typeMap[typeSelected].selected]);
      this.$emit("update:type", typeSelected);
      this.$emit("change");
    },
    onClear() {
      this.typeSelected = "011";
      const { typeMap } = this;
      Object.values(typeMap).forEach(v => {
        v.selected = [];
      });
      this.onConfirm();
    }
  }
};
</script>
